import { connect } from 'react-redux';
import SanctionsWarningsOverlayTable from '../../pages/SanctionsWarnings/SanctionsWarningsOverlayTable';
import { fetchEntitySanctions, resetEntitySanctions } from './SanctionsWarnings.actions';
import SanctionsSection from './../../pages/EntityDashboard/components/EntityAnalysis/SanctionsSection';
import SanctionReports from '../../pages/SanctionReports/SanctionReports.index';
import SanctionsWarningsTable from './../../pages/SanctionsWarnings/SanctionsWarningsTable';
import SanctionsWarningsTabbedListingPage from './../../pages/SanctionsWarnings/SanctionsWarningsTabbedListingPage';
import { SANCTIONS_CISIDS } from './../../constants';
import { injectIntl } from 'react-intl';

const sanctionsState = (state, ownProps) => {
    const items = state.sanctionsWarnings.singleEntity.items.map((item, index) => {
        item.index = index;
        return item;
    })
    return {
        items:      items,
        entityName: ownProps.entityName,
        companyId:  ownProps.companyId,
        cisIds: state.sanctionsWarnings.singleEntity.cisIDs,
        cisIdCodes: SANCTIONS_CISIDS,
        isLoading:  state.sanctionsWarnings.singleEntity.isLoading,
        totalCount: state.sanctionsWarnings.singleEntity.totalCount,
        hasError:   state.sanctionsWarnings.singleEntity.hasError,
        isFinished: state.sanctionsWarnings.singleEntity.isFinished
    }
};

const sanctionsDispatch = dispatch => {
    return {
        loadItems: (entityName, companyId) => { dispatch(fetchEntitySanctions(entityName, companyId)) },
        resetSanctions: () => { dispatch(resetEntitySanctions())}
    }
};

export const SanctionsWatchlistTableOverlay = connect(
    sanctionsState,
    sanctionsDispatch
)(SanctionsWarningsOverlayTable);

export const EntityDashboardSanctionsPod = injectIntl(connect(
    sanctionsState,
    sanctionsDispatch
)(SanctionsSection))

export const SanctionsListPage = injectIntl(connect(
    sanctionsState,
    sanctionsDispatch
)(SanctionsWarningsTabbedListingPage))



// -- Sanction Report for specific csid (used for tabbed sanction reports)

const singleSanctionState = (state, ownProps) => {
    if (state.sanctionsWarnings.singleEntity.cisIDs.length) {
        const singleEntityCisID = state.sanctionsWarnings.singleEntity.cisIDs.filter(item => item.id === ownProps.cisIDs[0])[0];
        const items = state.sanctionsWarnings.singleEntity.items.map((item, index) => {
            item.index = index;
            return item;
        }).filter(item => item.cisID === ownProps.cisIDs[0])

        return {
            ...ownProps,
            items:      items,
            isLoading:  singleEntityCisID.isLoading,
            totalCount: singleEntityCisID.totalCount,
            hasError:   singleEntityCisID.hasError,
            isFinished: singleEntityCisID.totalCount !== null && singleEntityCisID.totalCount < singleEntityCisID.start,
            autoLoad: true,
            backRoute: ownProps.backRoute
        }
    } else {
        return { ...ownProps, autoLoad: true }
    }
};

const singleSanctionDispatch = (dispatch, ownProps) => {
    return {
        loadItems: (entityName, companyId) => {
            dispatch(fetchEntitySanctions(entityName, companyId, ownProps.cisIDs))
        },
        resetSanctions: () => { dispatch(resetEntitySanctions())}
    }
};

export const SingleSanctionsWatchlistTable = connect(
    singleSanctionState,
    singleSanctionDispatch
)(SanctionsWarningsTable);


// -- Sanction mapStateToProps and dispatches for single sanction report view

const sanctionReportState = (state, ownProps) => {
    const items = state.sanctionsWarnings.singleEntity.items.map((item, index) => {
        item.index = index;
        return item;
    })
    return {
        items: items,
        index: parseInt(ownProps.params.index, 10),
        router: ownProps.router,
        totalCount: state.sanctionsWarnings.singleEntity.totalCount,
        entityName: state.sanctionsWarnings.singleEntity.entityName
    }
};

const sanctionReportDispatch = (dispatch, getState) => {
    return {
        loadItems: entityName => { dispatch(fetchEntitySanctions(entityName)) }
    }
};

export const SanctionReportsPage = connect(
    sanctionReportState,
    sanctionReportDispatch
)(SanctionReports);



// WEBPACK FOOTER //
// ./src/scripts/containers/SanctionsWarnings/SanctionsWarnings.containers.jsx